/**
 * @generated SignedSource<<1874fb3dc7d8e0780b8d7f26f10f1f4c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type useCurrentUserHasSeenNotificationNudgeModal_session$data = {
  readonly currentClientProfile: {
    readonly member: {
      readonly user?: {
        readonly metadata: {
          readonly hasSeenNotificationNudgeModal: boolean | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useCurrentUserHasSeenNotificationNudgeModal_session";
};
export type useCurrentUserHasSeenNotificationNudgeModal_session$key = {
  readonly " $data"?: useCurrentUserHasSeenNotificationNudgeModal_session$data;
  readonly " $fragmentSpreads": FragmentRefs<"useCurrentUserHasSeenNotificationNudgeModal_session">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "MemberUser",
    "kind": "LinkedField",
    "name": "user",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "UserMetadata",
        "kind": "LinkedField",
        "name": "metadata",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasSeenNotificationNudgeModal",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useCurrentUserHasSeenNotificationNudgeModal_session",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "currentClientProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "member",
          "plural": false,
          "selections": [
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Member",
              "abstractKey": null
            },
            {
              "kind": "InlineFragment",
              "selections": (v0/*: any*/),
              "type": "Customer",
              "abstractKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Session",
  "abstractKey": null
};
})();

(node as any).hash = "dea4a0e5d3fc887a57ace82a9e4eb0c8";

export default node;
